// extracted by mini-css-extract-plugin
module.exports = {"addButtons":"job_hiring_steps-module_addButtons_50315","confirmModalStepLabel":"job_hiring_steps-module_confirmModalStepLabel_93846"};